"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configuration_1 = require("./configuration");
var planeditor_1 = require("./planeditor");
var planeditor_2 = require("./planeditor");
var MEDIATYPES = {
    ONLINE: "onlinemedium",
    DIGITAL: "digitalmedium",
    MOBILE: "mobilemedium",
};
var ColumnSetFactory = (function () {
    function ColumnSetFactory() {
    }
    ColumnSetFactory.fixDataKeys = function (columnSet) {
        columnSet.forEach(function (page) {
            page.columns.forEach(function (column) {
                if (!column["dataKey"]) {
                    column["dataKey"] = column["dataPath"];
                }
            });
        });
        return columnSet;
    };
    ColumnSetFactory.getColumnSet = function (type, isDdf, useTimeClasses) {
        var result;
        switch (type.toLowerCase()) {
            case "top":
                result = ColumnSetFactory._columnSetTop;
                break;
            case "medimach":
                result = ColumnSetFactory._columnSetMedimach;
                break;
            case "stroer":
                result = ColumnSetFactory._columnSetMedimachStroer;
                break;
            default: {
                throw new Error("WARNING: ColumnSet " + type + " not found!");
            }
        }
        if (isDdf) {
            this.makeDdfPages(result);
        }
        if (!useTimeClasses) {
            this.stripTimeClasses(result);
        }
        return ColumnSetFactory.fixDataKeys(result);
    };
    ColumnSetFactory.makeDdfPages = function (pages) {
        pages.forEach(function (page) {
            var mediumPeriodIndex = _.findIndex(page.columns, function (column) { return _.get(column, "key") === "MEDIUM_PERIOD"; });
            if (mediumPeriodIndex > -1) {
                page.columns.splice(mediumPeriodIndex, 1, ColumnSetFactory._columnTypes.MEDIUM_PERIOD_DIALOG);
            }
        });
    };
    ColumnSetFactory.stripTimeClasses = function (pages) {
        _.remove(pages, function (page) { return page.key === "TIME_CLASSES"; });
    };
    ColumnSetFactory.getMediumColumnSet = function () {
        return ColumnSetFactory._mediumColumnSet;
    };
    ColumnSetFactory.getMediumColumnSetStroer = function () {
        return ColumnSetFactory._mediumColumnSetStroer;
    };
    ColumnSetFactory.getColumnTypes = function () {
        return ColumnSetFactory._columnTypes;
    };
    ColumnSetFactory._columnTypes = {
        AGENCY_COMMISSION: {
            key: "AGENCY_COMMISSION",
            caption: "Agency commission",
            dataPath: "conditions.agencyCommission",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_CURRENCY
            }
        },
        MEDIUM_NAME: {
            key: "MEDIUM_NAME",
            caption: "",
            dataPath: "groupCaption",
            settings: {
                width: 350
            },
            isGroupColumn: true
        },
        MEDIUM_NAME_STROER: {
            key: "MEDIUM_NAME_STROER",
            caption: "Produkt",
            dataPath: "groupCaption",
            settings: {
                width: 250
            },
            isGroupColumn: true
        },
        MEDIUM_TYPE: {
            key: "MEDIUM_TYPE",
            caption: "Medientyp",
            dataPath: "mediumType.title",
            settings: {
                width: 200,
                textOnEmpty: "",
                neverInvalidate: true
            }
        },
        ADD: {
            key: "ADD",
            caption: "",
            settings: {
                width: 26,
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.CENTER
            },
            editor: {
                type: planeditor_2.COLUMN_EDITORS.BUTTON,
                caption: "+",
                handler: "addRowHandler"
            }
        },
        REMOVE: {
            key: "REMOVE",
            caption: "",
            settings: {
                width: 26,
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.CENTER
            },
            editor: {
                type: planeditor_2.COLUMN_EDITORS.BUTTON,
                caption: "-",
                handler: "deleteRowHandler"
            }
        },
        TARGET_CPM_GROSS: {
            key: "TARGET_CPM_GROSS",
            caption: "Zielgr.-\nTKP EUR\n(Brutto)",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            dataPath: "cpmGross",
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_CURRENCY,
                width: 50,
                level: 1
            }
        },
        TARGET_CPM_NN: {
            key: "TARGET_CPM_NN",
            caption: "Zielgr.-\nTKP EUR\n(n.n.)",
            dataPath: "cpmNet",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_CURRENCY,
                level: 1
            }
        },
        GROSS: {
            key: "GROSS",
            caption: "Brutto / Netto",
            dataPath: "conditions.gross",
            dataType: planeditor_1.DATA_TYPES.BOOLEAN,
            editor: {
                type: planeditor_2.COLUMN_EDITORS.CHECKBOX
            },
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.CENTER,
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR
            }
        },
        AD_FORMAT: {
            key: "AD_FORMAT",
            caption: "Werbeform",
            dataPath: "conditions.online.adFormat",
            dataKey: "",
            dataType: planeditor_1.DATA_TYPES.LIST,
            editor: {
                type: planeditor_2.COLUMN_EDITORS.AD_FORMAT,
                config: {
                    popup: "adFormat"
                }
            },
            settings: {
                width: 128,
                collectForTotalRow: true
            }
        },
        AD_FORMAT_GENERIC: {
            key: "AD_FORMAT_GENERIC",
            caption: "Format/Werbeform",
            dataPath: "conditions",
            dataKey: "",
            dataType: planeditor_1.DATA_TYPES.LIST,
            editor: {
                type: planeditor_2.COLUMN_EDITORS.AD_FORMAT,
                config: {
                    popup: "adFormat"
                }
            },
            settings: {
                width: 128,
                collectForTotalRow: true
            }
        },
        AD_FORMAT_INFO: {
            key: "AD_FORMAT_INFO",
            caption: "Ausprä-\ngungen",
            dataPath: "additionalData.adformatInformation",
            dataType: planeditor_1.DATA_TYPES.TEXT,
            settings: {
                width: 60,
                invalidateOnlyRow: true
            }
        },
        USER_ANNOTATION: {
            key: "USER_ANNOTATION",
            caption: "Eigene Anmerkung",
            dataPath: "userAnnotation",
            dataType: planeditor_1.DATA_TYPES.TEXT,
            editor: {
                type: planeditor_2.COLUMN_EDITORS.TEXT_FIELD
            },
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR,
                width: 100,
                textOnEmpty: ""
            }
        },
        GROUP_TAG: {
            key: "GROUP_TAG",
            caption: "Gruppierung",
            dataPath: "group",
            dataType: planeditor_1.DATA_TYPES.TEXT,
            editor: {
                type: planeditor_2.COLUMN_EDITORS.DROP_DOWN,
                config: {
                    list: [""]
                },
                isEditableDropDown: true,
                stopEditingAfterwards: true,
                getValues: undefined,
                addValue: undefined
            },
            settings: {
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR,
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                width: 70
            }
        },
        TAG: {
            key: "TAG",
            caption: "tag",
            dataPath: "tag",
            settings: {
                width: 50
            }
        },
        MAX_CONTACTS_ADFORMAT: {
            key: "MAX_CONTACTS_ADFORMAT",
            caption: "Max. Kont./\nWerbeform\nin Tsd.",
            dataPath: "maxContactsAdformat",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_INTEGER,
                factor: 0.001,
                width: 70,
                highlightOnWarning: true,
                alwaysFloor: true,
                invalidateOnlyRow: true
            }
        },
        PRICING: {
            key: "PRICING",
            caption: "Pricing",
            dataPath: "conditions.online.pricing"
        },
        DATE: {
            key: "DATE",
            caption: "Date",
            dataPath: "conditions.rateCard.date",
            settings: {
                width: 100
            }
        },
        DATERULE: {
            key: "DATERULE",
            caption: "Date rule",
            dataPath: "conditions.rateCard.dateRule"
        },
        DAYSOFWEEK: {
            key: "DAYSOFWEEK",
            caption: "Days of week",
            dataPath: "conditions.rateCard.daysOfWeek"
        },
        VAT: {
            key: "VAT",
            caption: "VAT",
            dataPath: "conditions.vat",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_PERCENT
            }
        },
        TARGETING: {
            key: "TARGETING",
            types: [MEDIATYPES.ONLINE, MEDIATYPES.DIGITAL, MEDIATYPES.MOBILE],
            caption: "Targeting",
            dataPath: "targeting.keys",
            mouseHoverDataPath: "targetingSummaryLong",
            mouseHoverTextOnEmpty: "Kein Targeting",
            editor: {
                type: planeditor_2.COLUMN_EDITORS.TARGETING,
                config: {
                    popup: "targeting",
                    textOnEmpty: "Kein"
                }
            },
            settings: {
                width: 110
            }
        },
        TARGETING_WASTAGE: {
            key: "TARGETING_WASTAGE",
            caption: "Targeting\nStreu-\nverlust %",
            dataPath: "targeting.wastage",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_PERCENT,
                width: 55
            }
        },
        FREQUENCY: {
            key: "FREQUENCY",
            caption: "Freq.",
            longCaption: "Frequenz",
            dataPath: "frequency",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            editor: {
                type: planeditor_2.COLUMN_EDITORS.DROP_DOWN,
                config: {
                    list: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
                },
                isEditableDropDown: true
            },
            settings: {
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR,
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                width: 40
            }
        },
        FREQUENCY_TEXTFIELD: {
            key: "FREQUENCY",
            caption: "Freq.",
            longCaption: "Frequenz",
            dataPath: "frequency",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            editor: {
                type: planeditor_2.COLUMN_EDITORS.TEXT_FIELD
            },
            settings: {
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR,
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                width: 30
            }
        },
        FREQUENCYCAPPING_IMPRESSIONS: {
            key: "FREQUENCYCAPPING_IMPRESSIONS",
            caption: "FC",
            types: [MEDIATYPES.ONLINE, MEDIATYPES.DIGITAL, MEDIATYPES.MOBILE],
            dataPath: "additionalData.frequencyCappingFormatted",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_INTEGER,
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR,
                width: 30,
                maxValue: 999,
                readonlyWhenUndefined: true
            },
            editor: {
                type: planeditor_2.COLUMN_EDITORS.TEXT_FIELD
            }
        },
        FREQUENCYCAPPING_FORTOTAL: {
            key: "FREQUENCYCAPPING_FORTOTAL",
            caption: "FC pro\nZeit-\nraum",
            types: [MEDIATYPES.ONLINE, MEDIATYPES.DIGITAL, MEDIATYPES.MOBILE],
            dataPath: "additionalData.frequencyCappingForTotal",
            dataType: planeditor_1.DATA_TYPES.BOOLEAN,
            editor: {
                type: planeditor_2.COLUMN_EDITORS.CHECKBOX
            },
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.CENTER,
                width: 44
            }
        },
        FREQUENCYCAPPING_VALIDFOR: {
            key: "FREQUENCYCAPPING_VALIDFOR",
            caption: "FC gilt für",
            dataPath: "frequencyCappingValidFor",
            settings: {
                width: 65
            }
        },
        FREQUENCY_CAPPING_COST_PERCENT: {
            key: "FREQUENCY_CAPPING_COST_PERCENT",
            caption: "FC\n%",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            dataPath: "frequencyCappingCost.percent",
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_PERCENT
            }
        },
        FREQUENCY_CAPPING_COST_ABS: {
            key: "FREQUENCY_CAPPING_COST_ABS",
            caption: "FC\nabs.",
            dataPath: "frequencyCappingCost.absolute",
            dataType: planeditor_1.DATA_TYPES.CURRENCY,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_CURRENCY
            }
        },
        TARGETING_COST_PERCENT: {
            key: "TARGETING_COST_PERCENT",
            caption: "Targ.\n%",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            dataPath: "targetingCost.percent",
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_PERCENT
            }
        },
        TARGETING_COST_ABS: {
            key: "TARGETING_COST_ABS",
            caption: "Targ.\nabs.",
            dataPath: "targetingCost.absolute",
            dataType: planeditor_1.DATA_TYPES.CURRENCY,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_CURRENCY
            }
        },
        MEDIUM_KEY: {
            key: "MEDIUM_KEY",
            caption: "Medium - key",
            dataPath: "medium.key",
            settings: {
                width: 200
            }
        },
        MEDIUM_PERIOD: {
            key: "MEDIUM_PERIOD",
            caption: "Zeitraum",
            dataPath: "medium.period",
            types: [MEDIATYPES.ONLINE, MEDIATYPES.DIGITAL, MEDIATYPES.MOBILE],
            dataType: planeditor_1.DATA_TYPES.LIST,
            editor: {
                type: planeditor_2.COLUMN_EDITORS.DROP_DOWN,
                config: {
                    display: {}
                }
            },
            settings: {
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR,
                width: 80,
                collectForTotalRow: true
            }
        },
        MEDIUM_PERIOD_DIALOG: {
            key: "MEDIUM_PERIOD_DIALOG",
            caption: "Zeitraum",
            dataPath: "period",
            types: [MEDIATYPES.ONLINE, MEDIATYPES.DIGITAL, MEDIATYPES.MOBILE],
            dataKey: "",
            dataType: planeditor_1.DATA_TYPES.LIST,
            editor: {
                type: planeditor_2.COLUMN_EDITORS.PERIOD,
                config: {
                    popup: "period",
                    textOnEmpty: "Nicht gesetzt"
                }
            },
            settings: {
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR,
                width: 160,
                collectForTotalRow: false,
                highlightOnMissed67: true
            }
        },
        PAGE_IMPRESSIONS: {
            key: "PAGE_IMPRESSIONS",
            caption: "Belegung\nKont.\nin Tsd.",
            types: [MEDIATYPES.ONLINE, MEDIATYPES.DIGITAL, MEDIATYPES.MOBILE],
            dataPath: "pi",
            mouseHoverDataPath: "missed67text",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_INTEGER,
                factor: 0.001,
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR,
                width: 60,
                minValue: 0,
                highlightOnError: true,
                highlightOnWarning: true,
                showAlternativeTextOnMissed67: true
            },
            editor: {
                type: planeditor_2.COLUMN_EDITORS.TEXT_FIELD
            }
        },
        SHARE: {
            key: "SHARE",
            caption: "Share\n%",
            types: [MEDIATYPES.ONLINE, MEDIATYPES.DIGITAL, MEDIATYPES.MOBILE],
            dataPath: "share",
            mouseHoverDataPath: "missed67text",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            editor: {
                type: planeditor_2.COLUMN_EDITORS.TEXT_FIELD
            },
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR,
                minValue: 0,
                maxValue: 100,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_PERCENT,
                factor: 100,
                width: 40,
                highlightOnError: true,
                highlightOnWarning: true,
                showAlternativeTextOnMissed67: true
            }
        },
        GRP: {
            key: "GRP",
            caption: "GRP",
            dataPath: "grp",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_PERCENT,
                width: 50,
                level: 1
            }
        },
        CONTACTS_TOTAL: {
            key: "CONTACTS_TOTAL",
            caption: "Kontakte\nGesamt\nin Tsd.",
            dataPath: "contacts_total",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_INTEGER,
                factor: 0.001,
                width: 60,
                alwaysFloor: true,
                invalidateOnlyRow: true
            }
        },
        MAX_CONTACTS: {
            key: "MAX_CONTACTS",
            caption: "Maximale\nKont.\n in Tsd.",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            dataPath: "piMax",
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_INTEGER,
                factor: 0.001,
                width: 60,
                highlightOnError: true,
                alwaysFloor: true,
                invalidateOnlyRow: true
            }
        },
        GROSS_COST_EUR: {
            key: "GROSS_COST_EUR",
            caption: "Brutto-\nkosten\nEUR",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            dataPath: "gross",
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_CURRENCY,
                width: 75
            }
        },
        CPM: {
            key: "CPM",
            caption: "Basis-\nTKP\nin EUR",
            dataPath: "cpm",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_CURRENCY,
                width: 50
            }
        },
        UU_PERCENT: {
            key: "UU_PERCENT",
            caption: "Reichw.\nUU\n%",
            dataPath: "uu_percent",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_PERCENT,
                width: 50,
                level: 1
            }
        },
        UU_MILLION: {
            key: "UU_MILLION",
            caption: "Unique\nUser\nMio.",
            dataPath: "projection",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: "0.00",
                factor: 0.000001,
                width: 50,
                level: 1
            }
        },
        UU_PERCENT_MEDIMACH: {
            key: "UU_PERCENT_MEDIMACH",
            caption: "Reichweite\n%",
            dataPath: "uu_percent",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_PERCENT,
                width: 60
            }
        },
        UU_MILLION_MEDIMACH: {
            key: "UU_MILLION_MEDIMACH",
            caption: "Reichweite\nMio.",
            dataPath: "projection",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: "0.00",
                factor: 0.000001,
                width: 60
            }
        },
        AUDIENCE_CONTACTS_MIO: {
            key: "AUDIENCE_CONTACTS_MIO",
            caption: "Zielgr.-\nKontakte\nin Mio.",
            dataPath: "audienceContacts",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                factor: 0.000001,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_2DIGITS,
                width: 50,
                level: 1
            }
        },
        AUDIENCE_CONTACTS: {
            key: "AUDIENCE_CONTACTS",
            caption: "Zielgr.-\nKontakte",
            dataPath: "audienceContacts",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                factor: 0.000001,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_2DIGITS,
                level: 1
            }
        },
        AVERAGE_CONTACTS: {
            key: "AVERAGE_CONTACTS",
            caption: "Ø-Kont.",
            dataPath: "average_contacts",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_PERCENT,
                width: 50,
                level: 1
            }
        },
        USER_SHARE_PERCENT: {
            key: "USER_SHARE_PERCENT",
            caption: "Nutzer-\nAnteil\nin %",
            dataPath: "user_share",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_PERCENT,
                level: 2
            }
        },
        AFFINITY_INDEX: {
            key: "AFFINITY_INDEX",
            caption: "Aff.-\nindex",
            dataPath: "affinityIndex",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_NODIGITS,
                level: 2
            }
        },
        MARKETER: {
            key: "MARKETER",
            caption: "Vermarkter",
            dataPath: "marketerName",
            settings: {
                width: 200,
                neverInvalidate: true
            }
        },
        MARKETER_NAME: {
            key: "MARKETER_NAME",
            caption: "Ansprechpartner",
            dataPath: "conditions.online.contact.fullName",
            settings: {
                width: 200,
                neverInvalidate: true
            }
        },
        MARKETER_PHONE: {
            key: "MARKETER_PHONE",
            caption: "Telefon",
            dataPath: "conditions.online.contact.phone",
            settings: {
                width: 150,
                neverInvalidate: true
            }
        },
        MARKETER_EMAIL: {
            key: "MARKETER_EMAIL",
            caption: "E-Mail",
            dataPath: "conditions.online.contact.mail",
            dataType: planeditor_1.DATA_TYPES.LINK,
            settings: {
                width: 250,
                neverInvalidate: true
            }
        },
        MARKETER_WEB: {
            key: "MARKETER_WEB",
            caption: "Web",
            dataPath: "conditions.online.contact.web",
            dataType: planeditor_1.DATA_TYPES.LINK,
            settings: {
                width: 250,
                neverInvalidate: true
            }
        },
        RATE_CARD_CPM: {
            key: "RATE_CARD_CPM",
            caption: "Preisl.-\nTKP\nin EUR",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            dataPath: "base_tkp",
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_CURRENCY
            }
        },
        FIXED_PRICE_EUR: {
            key: "FIXED_PRICE_EUR",
            caption: "Festpreis\nin EUR",
            dataPath: "fixedPrice.amount",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_CURRENCY
            }
        },
        FIXED_PRICE_SHARE: {
            key: "FIXED_PRICE_SHARE",
            caption: "Festpreis\nmit Share",
            dataType: planeditor_1.DATA_TYPES.BOOLEAN,
            dataPath: "conditions.online.fixedPriceWithShare",
            editor: {
                type: planeditor_2.COLUMN_EDITORS.CHECKBOX
            },
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.CENTER,
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR
            }
        },
        CALCULATION: {
            key: "CALCULATION",
            caption: "Berechnung",
            dataPath: "additionalData.calculationTypeName"
        },
        FREQUENCY_INDIVIDUAL_FIXED_PRICE: {
            key: "FREQUENCY_INDIVIDUAL_FIXED_PRICE",
            caption: "Freq. bei\nindiv. Festpr.",
            dataPath: "additionalData.ignoreFrequencyString"
        },
        INDIVIDUAL_FIXED_PRICE: {
            key: "INDIVIDUAL_FIXED_PRICE",
            caption: "Individueller\nTKP/Festpreis",
            dataPath: "additionalData.specialPriceData",
            editor: {
                type: planeditor_2.COLUMN_EDITORS.SPECIAL_PRICE,
                config: {
                    textOnEmpty: "Nicht gesetzt"
                }
            },
            settings: {
                width: 100,
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR
            }
        },
        TOTAL_CPM: {
            key: "TOTAL_CPM",
            caption: "Gesamt-\nTKP",
            dataPath: "cpmTotal",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_CURRENCY
            }
        },
        NET_AFTER_RATE_CARD_DISCOUNT: {
            key: "NET_AFTER_RATE_CARD_DISCOUNT",
            caption: "Netto nach\nPrl-Rabatt\nEUR",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            dataPath: "nettoAfterPriceListGross",
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_CURRENCY
            }
        },
        DISCOUNT_ADDITIVE_CONSECUTIVE: {
            key: "DISCOUNT_ADDITIVE_CONSECUTIVE",
            caption: "Rabatt\nAdditiv/\nkonsek.",
            dataPath: "specialDiscounts.type",
            editor: {
                type: planeditor_2.COLUMN_EDITORS.DROP_DOWN,
                config: {
                    display: { additive: "additiv", consecutive: "konsekutiv" },
                    defaultValue: "additiv"
                }
            },
            settings: {
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR
            }
        },
        RATE_CARD_DISCOUNT: {
            key: "RATE_CARD_DISCOUNT",
            caption: "Preislisten\n-rabatt",
            dataPath: "conditions.gross",
            editor: {
                type: planeditor_2.COLUMN_EDITORS.DROP_DOWN,
                config: {
                    display: { false: "anwenden", true: "ignorieren" },
                    defaultValue: "anwenden"
                }
            },
            settings: {
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR,
                neverInvalidate: true
            }
        },
        SPECIAL_DISCOUNT: {
            key: "SPECIAL_DISCOUNT",
            caption: "Sonder-\nrabatt",
            dataPath: "additionalData.specialDiscount",
            editor: {
                type: planeditor_2.COLUMN_EDITORS.DROP_DOWN,
                config: {
                    list: ["Individuell", "Keinen"],
                    defaultValue: "Keinen"
                }
            },
            settings: {
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR
            }
        },
        DISCOUNT_1_PERCENT: {
            key: "DISCOUNT_1_PERCENT",
            caption: "Rabatt 1\n%",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            dataPath: "specialDiscounts.amount1",
            editor: {
                type: planeditor_2.COLUMN_EDITORS.TEXT_FIELD
            },
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_PERCENT,
                minValue: 0,
                maxValue: 100
            }
        },
        DISCOUNT_1_NET: {
            key: "DISCOUNT_1_NET",
            caption: "Netto nach\nRabatt 1\nEUR",
            dataPath: "specialDiscounts.absolute1",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_CURRENCY
            }
        },
        DISCOUNT_2_PERCENT: {
            key: "DISCOUNT_2_PERCENT",
            caption: "Rabatt 2\n%",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            dataPath: "specialDiscounts.amount2",
            editor: {
                type: planeditor_2.COLUMN_EDITORS.TEXT_FIELD
            },
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_PERCENT,
                minValue: 0,
                maxValue: 100
            }
        },
        DISCOUNT_2_NET: {
            key: "DISCOUNT_2_NET",
            caption: "Netto nach\nRabatt 2\nEUR",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            dataPath: "specialDiscounts.absolute2",
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_CURRENCY
            }
        },
        DISCOUNT_3_PERCENT: {
            key: "DISCOUNT_3_PERCENT",
            caption: "Rabatt 3\n%",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            dataPath: "specialDiscounts.amount3",
            editor: {
                type: planeditor_2.COLUMN_EDITORS.TEXT_FIELD
            },
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_PERCENT,
                minValue: 0,
                maxValue: 100,
                width: 75
            }
        },
        DISCOUNT_3_NET: {
            key: "DISCOUNT_3_NET",
            caption: "Netto nach\nRabatt 3\nEUR",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            dataPath: "specialDiscounts.absolute3",
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_CURRENCY,
                width: 75
            }
        },
        DISCOUNT_4_PERCENT: {
            key: "DISCOUNT_4_PERCENT",
            caption: "Rabatt 4\n%",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            dataPath: "specialDiscounts.amount4",
            editor: {
                type: planeditor_2.COLUMN_EDITORS.TEXT_FIELD
            },
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_PERCENT,
                minValue: 0,
                maxValue: 100,
                width: 75
            }
        },
        DISCOUNT_4_NET: {
            key: "DISCOUNT_4_NET",
            caption: "Netto nach\nRabatt 4\nEUR",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            dataPath: "specialDiscounts.absolute4",
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_CURRENCY,
                width: 75
            }
        },
        DISCOUNT_5_PERCENT: {
            key: "DISCOUNT_5_PERCENT",
            caption: "Rabatt 5\n%",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            dataPath: "specialDiscounts.amount5",
            editor: {
                type: planeditor_2.COLUMN_EDITORS.TEXT_FIELD
            },
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_PERCENT,
                minValue: 0,
                maxValue: 100,
                width: 75
            }
        },
        DISCOUNT_5_NET: {
            key: "DISCOUNT_5_NET",
            caption: "Netto nach\nRabatt 5\nEUR",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            dataPath: "specialDiscounts.absolute5",
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_CURRENCY,
                width: 75
            }
        },
        AE_PERCENT: {
            key: "AE_PERCENT",
            caption: "AE\n%",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            dataPath: "conditions.agencyCommission",
            editor: {
                type: planeditor_2.COLUMN_EDITORS.TEXT_FIELD
            },
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_PERCENT,
                minValue: 0,
                maxValue: 100
            }
        },
        AE_EUR: {
            key: "AE_EUR",
            caption: "Nach AE\nEUR",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            dataPath: "specialDiscounts.absoluteAE",
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_CURRENCY
            }
        },
        CASH_DISCOUNT_PERCENT: {
            key: "CASH_DISCOUNT_PERCENT",
            caption: "Skonto\n%",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            dataPath: "conditions.cashDiscount",
            editor: {
                type: planeditor_2.COLUMN_EDITORS.TEXT_FIELD
            },
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_PERCENT,
                minValue: 0,
                maxValue: 100
            }
        },
        CASH_DISCOUNT_EUR: {
            key: "CASH_DISCOUNT_EUR",
            caption: "Nach Skonto\nEUR",
            dataPath: "specialDiscounts.absoluteCashDiscount",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_CURRENCY
            }
        },
        VAT_PERCENT: {
            key: "VAT_PERCENT",
            caption: "MwSt.\n%",
            dataPath: "conditions.vat",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            editor: {
                type: planeditor_2.COLUMN_EDITORS.TEXT_FIELD
            },
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_PERCENT,
                minValue: 0,
                maxValue: 100
            }
        },
        VAT_EUR: {
            key: "VAT_EUR",
            caption: "Nach\nMwSt.\nEUR",
            dataPath: "specialDiscounts.net",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_CURRENCY
            }
        },
        POSTER_TYPE: {
            key: "POSTER_TYPE",
            caption: "posterType",
            longCaption: "Produkt",
            dataPath: "additionalData.posterType",
            dataType: planeditor_1.DATA_TYPES.LIST,
            editor: {
                type: planeditor_2.COLUMN_EDITORS.DROP_DOWN,
                subType: "poster",
                config: {}
            },
            settings: {
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR,
                width: 0,
                excludeFromExport: true
            }
        },
        POSTER_HOUR: {
            key: "POSTER_HOUR",
            caption: "Stunde",
            dataPath: "additionalData.posterHour",
            dataType: planeditor_1.DATA_TYPES.LIST,
            editor: {
                type: planeditor_2.COLUMN_EDITORS.DROP_DOWN,
                subType: "poster",
                config: {}
            },
            settings: {
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR,
                width: 130
            }
        },
        POSTER_WEEKDAY: {
            key: "POSTER_WEEKDAY",
            caption: "Wochentag",
            dataPath: "additionalData.posterWeekday",
            dataType: planeditor_1.DATA_TYPES.LIST,
            editor: {
                type: planeditor_2.COLUMN_EDITORS.DROP_DOWN,
                subType: "poster",
                config: {}
            },
            settings: {
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR,
                width: 120
            }
        },
        POSTER_SPOTLENGTH: {
            key: "POSTER_SPOTLENGTH",
            caption: "Spotlänge / Schaltungsdichte",
            dataPath: "additionalData.posterSpotLength",
            dataType: planeditor_1.DATA_TYPES.LIST,
            editor: {
                type: planeditor_2.COLUMN_EDITORS.DROP_DOWN,
                subType: "poster",
                config: {}
            },
            settings: {
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR,
                width: 210
            }
        },
        POSTER_REGION: {
            key: "POSTER_REGION",
            caption: "Region",
            dataPath: "additionalData.posterRegion",
            dataType: planeditor_1.DATA_TYPES.LIST,
            editor: {
                type: planeditor_2.COLUMN_EDITORS.DROP_DOWN,
                subType: "poster",
                config: {}
            },
            settings: {
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR,
                width: 220
            }
        },
        POSTER_PERIOD: {
            key: "POSTER_PERIOD",
            caption: "Zeitraum",
            dataPath: "period",
            dataType: planeditor_1.DATA_TYPES.LIST,
            editor: {
                type: planeditor_2.COLUMN_EDITORS.DROP_DOWN,
                subType: "poster",
                config: {
                    display: { Quartal123: "1. - 3. Quartal", Quartal4: "4. Quartal" },
                    defaultValue: "1. - 3. Quartal"
                }
            },
            settings: {
                background: configuration_1.PlanConfiguration.INPUT_BACKGROUND_COLOR,
                width: 90
            }
        },
        POSTER_PORTRAIT: {
            key: "POSTER_PORTRAIT",
            caption: "Flächen-\nanzahl\nHochf.",
            dataPath: "additionalData.posterPortrait",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                width: 50,
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_INTEGER
            }
        },
        POSTER_LANDSCAPE: {
            key: "POSTER_LANDSCAPE",
            caption: "Flächen-\nanzahl\nQuerf.",
            dataPath: "additionalData.posterLandscape",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                width: 50,
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_INTEGER
            }
        },
        POSTER_INFO: {
            key: "POSTER_INFO",
            caption: "Info",
            dataPath: "additionalData.infoText",
            dataType: planeditor_1.DATA_TYPES.IMAGE,
            mouseHoverDataPath: "additionalData.infoText",
            settings: {
                width: 30,
                showOnPresetRow: false
            }
        },
        TIME_CLASSES0: {
            key: "TIME_CLASSES0",
            caption: "Zeitklassen\n1 - u. 10 Sek.\nKontakte Mio.",
            dataPath: "timeClasses0",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                factor: 0.000001,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_2DIGITS,
                width: 80
            }
        },
        TIME_CLASSES1: {
            key: "TIME_CLASSES1",
            caption: "Zeitklassen\n10 - u. 30. Sek.\nKontakte Mio.",
            dataPath: "timeClasses1",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                factor: 0.000001,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_2DIGITS,
                width: 80
            }
        },
        TIME_CLASSES2: {
            key: "TIME_CLASSES2",
            caption: "Zeitklassen\n30 - u. 60. Sek.\nKontakte Mio.",
            dataPath: "timeClasses2",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                factor: 0.000001,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_2DIGITS,
                width: 80
            }
        },
        TIME_CLASSES3: {
            key: "TIME_CLASSES3",
            caption: "Zeitklassen\n60 - u. 300. Sek.\nKontakte Mio.",
            dataPath: "timeClasses3",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                factor: 0.000001,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_2DIGITS,
                width: 80
            }
        },
        TIME_CLASSES4: {
            key: "TIME_CLASSES4",
            caption: "Zeitklassen\nüber 300 Sek.\nKontakte Mio.",
            dataPath: "timeClasses4",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                factor: 0.000001,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_2DIGITS,
                width: 80
            }
        },
        TIME_CLASSES0_PERCENT: {
            key: "TIME_CLASSES0_PERCENT",
            caption: "Zeitklassen\n1 - u. 10 Sek.\nAnteil % (horiz.)",
            dataPath: "timeClasses0_percent",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_PERCENT,
                width: 80
            }
        },
        TIME_CLASSES1_PERCENT: {
            key: "TIME_CLASSES1_PERCENT",
            caption: "Zeitklassen\n10 - u. 30 Sek.\nAnteil % (horiz.)",
            dataPath: "timeClasses1_percent",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_PERCENT,
                width: 80
            }
        },
        TIME_CLASSES2_PERCENT: {
            key: "TIME_CLASSES2_PERCENT",
            caption: "Zeitklassen\n30 - u. 60 Sek.\nAnteil % (horiz.)",
            dataPath: "timeClasses2_percent",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_PERCENT,
                width: 80
            }
        },
        TIME_CLASSES3_PERCENT: {
            key: "TIME_CLASSES3_PERCENT",
            caption: "Zeitklassen\n60 - u. 300 Sek.\nAnteil % (horiz.)",
            dataPath: "timeClasses3_percent",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_PERCENT,
                width: 80
            }
        },
        TIME_CLASSES4_PERCENT: {
            key: "TIME_CLASSES4_PERCENT",
            caption: "Zeitklassen\nüber 300 Sek.\nAnteil % (horiz.)",
            dataPath: "timeClasses4_percent",
            dataType: planeditor_1.DATA_TYPES.NUMBER,
            settings: {
                xAlign: planeditor_1.HORIZONTAL_ALIGNMENTS.RIGHT,
                numberFormat: configuration_1.PlanConfiguration.NUMBER_FORMAT_PERCENT,
                width: 80
            }
        }
    };
    ColumnSetFactory._mediumColumnSet = {
        key: "INPUT",
        name: "input",
        columns: [
            ColumnSetFactory._columnTypes.MEDIUM_NAME,
            ColumnSetFactory._columnTypes.ADD,
            ColumnSetFactory._columnTypes.REMOVE
        ]
    };
    ColumnSetFactory._mediumColumnSetStroer = {
        key: "INPUT",
        name: "input",
        columns: [
            ColumnSetFactory._columnTypes.MEDIUM_NAME_STROER,
            ColumnSetFactory._columnTypes.REMOVE
        ]
    };
    ColumnSetFactory._columnsTop = {
        INPUT: {
            key: "INPUT",
            name: "Belegung",
            columns: [
                ColumnSetFactory._columnTypes.MEDIUM_TYPE,
                ColumnSetFactory._columnTypes.FREQUENCY,
                ColumnSetFactory._columnTypes.MEDIUM_PERIOD,
                ColumnSetFactory._columnTypes.SHARE,
                ColumnSetFactory._columnTypes.PAGE_IMPRESSIONS,
                ColumnSetFactory._columnTypes.AD_FORMAT,
                ColumnSetFactory._columnTypes.AD_FORMAT_INFO,
                ColumnSetFactory._columnTypes.USER_ANNOTATION,
                ColumnSetFactory._columnTypes.CONTACTS_TOTAL,
                ColumnSetFactory._columnTypes.MAX_CONTACTS,
                ColumnSetFactory._columnTypes.MAX_CONTACTS_ADFORMAT,
                ColumnSetFactory._columnTypes.CPM,
                ColumnSetFactory._columnTypes.FREQUENCYCAPPING_IMPRESSIONS,
                ColumnSetFactory._columnTypes.FREQUENCYCAPPING_FORTOTAL,
                ColumnSetFactory._columnTypes.FREQUENCYCAPPING_VALIDFOR,
                ColumnSetFactory._columnTypes.TARGETING,
                ColumnSetFactory._columnTypes.TARGETING_WASTAGE,
                ColumnSetFactory._columnTypes.GROUP_TAG,
                ColumnSetFactory._columnTypes.GROSS_COST_EUR,
                ColumnSetFactory._columnTypes.DISCOUNT_5_NET
            ]
        },
        INPUT_DDF: {
            key: "INPUT_DDF",
            name: "Belegung",
            columns: [
                ColumnSetFactory._columnTypes.MEDIUM_TYPE,
                ColumnSetFactory._columnTypes.FREQUENCY,
                ColumnSetFactory._columnTypes.MEDIUM_PERIOD,
                ColumnSetFactory._columnTypes.SHARE,
                ColumnSetFactory._columnTypes.PAGE_IMPRESSIONS,
                ColumnSetFactory._columnTypes.AD_FORMAT,
                ColumnSetFactory._columnTypes.AD_FORMAT_INFO,
                ColumnSetFactory._columnTypes.USER_ANNOTATION,
                ColumnSetFactory._columnTypes.CONTACTS_TOTAL,
                ColumnSetFactory._columnTypes.MAX_CONTACTS,
                ColumnSetFactory._columnTypes.MAX_CONTACTS_ADFORMAT,
                ColumnSetFactory._columnTypes.CPM,
                ColumnSetFactory._columnTypes.FREQUENCYCAPPING_IMPRESSIONS,
                ColumnSetFactory._columnTypes.FREQUENCYCAPPING_FORTOTAL,
                ColumnSetFactory._columnTypes.FREQUENCYCAPPING_VALIDFOR,
                ColumnSetFactory._columnTypes.TARGETING,
                ColumnSetFactory._columnTypes.TARGETING_WASTAGE,
                ColumnSetFactory._columnTypes.GROUP_TAG,
                ColumnSetFactory._columnTypes.GROSS_COST_EUR,
                ColumnSetFactory._columnTypes.DISCOUNT_5_NET
            ]
        },
        PERFORMANCE: {
            key: "PERFORMANCE",
            name: "Leistungswerte",
            columns: [
                ColumnSetFactory._columnTypes.FREQUENCY,
                ColumnSetFactory._columnTypes.MEDIUM_PERIOD,
                ColumnSetFactory._columnTypes.SHARE,
                ColumnSetFactory._columnTypes.PAGE_IMPRESSIONS,
                ColumnSetFactory._columnTypes.CONTACTS_TOTAL,
                ColumnSetFactory._columnTypes.GROSS_COST_EUR,
                ColumnSetFactory._columnTypes.DISCOUNT_3_NET,
                ColumnSetFactory._columnTypes.TARGET_CPM_GROSS,
                ColumnSetFactory._columnTypes.TARGET_CPM_NN,
                ColumnSetFactory._columnTypes.UU_PERCENT,
                ColumnSetFactory._columnTypes.UU_MILLION,
                ColumnSetFactory._columnTypes.AUDIENCE_CONTACTS_MIO,
                ColumnSetFactory._columnTypes.GRP,
                ColumnSetFactory._columnTypes.AVERAGE_CONTACTS,
                ColumnSetFactory._columnTypes.USER_SHARE_PERCENT,
                ColumnSetFactory._columnTypes.AFFINITY_INDEX
            ]
        },
        COST_CALCULATION_1: {
            key: "COST_CALCULATION_1",
            name: "Kosten 1",
            columns: [
                ColumnSetFactory._columnTypes.FREQUENCY,
                ColumnSetFactory._columnTypes.MEDIUM_PERIOD,
                ColumnSetFactory._columnTypes.SHARE,
                ColumnSetFactory._columnTypes.PAGE_IMPRESSIONS,
                ColumnSetFactory._columnTypes.AD_FORMAT,
                ColumnSetFactory._columnTypes.AD_FORMAT_INFO,
                ColumnSetFactory._columnTypes.USER_ANNOTATION,
                ColumnSetFactory._columnTypes.CONTACTS_TOTAL,
                ColumnSetFactory._columnTypes.RATE_CARD_CPM,
                ColumnSetFactory._columnTypes.FIXED_PRICE_EUR,
                ColumnSetFactory._columnTypes.FIXED_PRICE_SHARE,
                ColumnSetFactory._columnTypes.CALCULATION,
                ColumnSetFactory._columnTypes.FREQUENCY_INDIVIDUAL_FIXED_PRICE,
                ColumnSetFactory._columnTypes.INDIVIDUAL_FIXED_PRICE,
                ColumnSetFactory._columnTypes.CPM,
                ColumnSetFactory._columnTypes.FREQUENCY_CAPPING_COST_PERCENT,
                ColumnSetFactory._columnTypes.FREQUENCY_CAPPING_COST_ABS,
                ColumnSetFactory._columnTypes.TARGETING_COST_PERCENT,
                ColumnSetFactory._columnTypes.TARGETING_COST_ABS,
                ColumnSetFactory._columnTypes.TOTAL_CPM
            ]
        },
        COST_CALCULATION_2: {
            key: "COST_CALCULATION_2",
            name: "Kosten 2",
            columns: [
                ColumnSetFactory._columnTypes.FREQUENCY,
                ColumnSetFactory._columnTypes.MEDIUM_PERIOD,
                ColumnSetFactory._columnTypes.SHARE,
                ColumnSetFactory._columnTypes.PAGE_IMPRESSIONS,
                ColumnSetFactory._columnTypes.AD_FORMAT,
                ColumnSetFactory._columnTypes.AD_FORMAT_INFO,
                ColumnSetFactory._columnTypes.USER_ANNOTATION,
                ColumnSetFactory._columnTypes.CONTACTS_TOTAL,
                ColumnSetFactory._columnTypes.TOTAL_CPM,
                ColumnSetFactory._columnTypes.GROSS_COST_EUR,
                ColumnSetFactory._columnTypes.NET_AFTER_RATE_CARD_DISCOUNT,
                ColumnSetFactory._columnTypes.DISCOUNT_ADDITIVE_CONSECUTIVE,
                ColumnSetFactory._columnTypes.RATE_CARD_DISCOUNT,
                ColumnSetFactory._columnTypes.SPECIAL_DISCOUNT,
                ColumnSetFactory._columnTypes.DISCOUNT_1_PERCENT,
                ColumnSetFactory._columnTypes.DISCOUNT_1_NET,
                ColumnSetFactory._columnTypes.DISCOUNT_2_PERCENT,
                ColumnSetFactory._columnTypes.DISCOUNT_2_NET,
                ColumnSetFactory._columnTypes.DISCOUNT_3_PERCENT,
                ColumnSetFactory._columnTypes.DISCOUNT_3_NET,
                ColumnSetFactory._columnTypes.DISCOUNT_4_PERCENT,
                ColumnSetFactory._columnTypes.DISCOUNT_4_NET,
                ColumnSetFactory._columnTypes.DISCOUNT_5_PERCENT,
                ColumnSetFactory._columnTypes.DISCOUNT_5_NET,
                ColumnSetFactory._columnTypes.AE_PERCENT,
                ColumnSetFactory._columnTypes.AE_EUR,
                ColumnSetFactory._columnTypes.CASH_DISCOUNT_PERCENT,
                ColumnSetFactory._columnTypes.CASH_DISCOUNT_EUR,
                ColumnSetFactory._columnTypes.VAT_PERCENT,
                ColumnSetFactory._columnTypes.VAT_EUR
            ]
        },
        MARKETER_INFO: {
            key: "MARKETER_INFO",
            name: "Vermarkterinfo",
            columns: [
                ColumnSetFactory._columnTypes.MARKETER,
                ColumnSetFactory._columnTypes.MARKETER_NAME,
                ColumnSetFactory._columnTypes.MARKETER_PHONE,
                ColumnSetFactory._columnTypes.MARKETER_EMAIL,
                ColumnSetFactory._columnTypes.MARKETER_WEB
            ]
        },
        TIME_CLASSES: {
            key: "TIME_CLASSES",
            name: "Zeitklassen",
            columns: [
                ColumnSetFactory._columnTypes.FREQUENCY,
                ColumnSetFactory._columnTypes.MEDIUM_PERIOD,
                ColumnSetFactory._columnTypes.SHARE,
                ColumnSetFactory._columnTypes.PAGE_IMPRESSIONS,
                ColumnSetFactory._columnTypes.AUDIENCE_CONTACTS_MIO,
                ColumnSetFactory._columnTypes.TIME_CLASSES0,
                ColumnSetFactory._columnTypes.TIME_CLASSES1,
                ColumnSetFactory._columnTypes.TIME_CLASSES2,
                ColumnSetFactory._columnTypes.TIME_CLASSES3,
                ColumnSetFactory._columnTypes.TIME_CLASSES4,
                ColumnSetFactory._columnTypes.TIME_CLASSES0_PERCENT,
                ColumnSetFactory._columnTypes.TIME_CLASSES1_PERCENT,
                ColumnSetFactory._columnTypes.TIME_CLASSES2_PERCENT,
                ColumnSetFactory._columnTypes.TIME_CLASSES3_PERCENT,
                ColumnSetFactory._columnTypes.TIME_CLASSES4_PERCENT
            ]
        }
    };
    ColumnSetFactory._columnsMedimach = {
        INPUT: {
            key: "INPUT",
            name: "Belegung",
            columns: [
                ColumnSetFactory._columnTypes.FREQUENCY_TEXTFIELD,
                ColumnSetFactory._columnTypes.MEDIUM_PERIOD,
                ColumnSetFactory._columnTypes.SHARE,
                ColumnSetFactory._columnTypes.PAGE_IMPRESSIONS,
                ColumnSetFactory._columnTypes.AD_FORMAT_GENERIC,
                ColumnSetFactory._columnTypes.CPM,
                ColumnSetFactory._columnTypes.FREQUENCYCAPPING_IMPRESSIONS,
                ColumnSetFactory._columnTypes.FREQUENCYCAPPING_FORTOTAL,
                ColumnSetFactory._columnTypes.TARGETING,
                ColumnSetFactory._columnTypes.USER_ANNOTATION,
                ColumnSetFactory._columnTypes.GROUP_TAG,
                ColumnSetFactory._columnTypes.GROSS_COST_EUR,
                ColumnSetFactory._columnTypes.TARGET_CPM_GROSS,
                ColumnSetFactory._columnTypes.UU_PERCENT_MEDIMACH,
                ColumnSetFactory._columnTypes.UU_MILLION_MEDIMACH,
                ColumnSetFactory._columnTypes.AUDIENCE_CONTACTS_MIO,
                ColumnSetFactory._columnTypes.GRP,
                ColumnSetFactory._columnTypes.USER_SHARE_PERCENT,
                ColumnSetFactory._columnTypes.AFFINITY_INDEX
            ]
        }
    };
    ColumnSetFactory._columnsMedimachStroer = {
        INPUT: {
            key: "INPUT",
            name: "Belegung",
            columns: [
                ColumnSetFactory._columnTypes.POSTER_TYPE,
                ColumnSetFactory._columnTypes.POSTER_SPOTLENGTH,
                ColumnSetFactory._columnTypes.POSTER_REGION,
                ColumnSetFactory._columnTypes.POSTER_INFO,
                ColumnSetFactory._columnTypes.POSTER_PORTRAIT,
                ColumnSetFactory._columnTypes.POSTER_LANDSCAPE,
                ColumnSetFactory._columnTypes.POSTER_WEEKDAY,
                ColumnSetFactory._columnTypes.POSTER_HOUR,
                ColumnSetFactory._columnTypes.POSTER_PERIOD,
                ColumnSetFactory._columnTypes.FREQUENCY_TEXTFIELD,
                ColumnSetFactory._columnTypes.UU_PERCENT,
                ColumnSetFactory._columnTypes.UU_MILLION,
                ColumnSetFactory._columnTypes.AUDIENCE_CONTACTS_MIO,
                ColumnSetFactory._columnTypes.AVERAGE_CONTACTS,
                ColumnSetFactory._columnTypes.GRP,
                ColumnSetFactory._columnTypes.TARGET_CPM_GROSS,
                ColumnSetFactory._columnTypes.GROSS_COST_EUR
            ]
        }
    };
    ColumnSetFactory._columnSetTop = [
        ColumnSetFactory._columnsTop.INPUT,
        ColumnSetFactory._columnsTop.PERFORMANCE,
        ColumnSetFactory._columnsTop.COST_CALCULATION_1,
        ColumnSetFactory._columnsTop.COST_CALCULATION_2,
        ColumnSetFactory._columnsTop.MARKETER_INFO,
        ColumnSetFactory._columnsTop.TIME_CLASSES
    ];
    ColumnSetFactory._columnSetMedimach = [
        ColumnSetFactory._columnsMedimach.INPUT
    ];
    ColumnSetFactory._columnSetMedimachStroer = [
        ColumnSetFactory._columnsMedimachStroer.INPUT
    ];
    return ColumnSetFactory;
}());
exports.ColumnSetFactory = ColumnSetFactory;
//# sourceMappingURL=columnSetFactory.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/columnSetFactory.js
// module id = 4
// module chunks = 0